











import Vue from 'vue';
import FeatureService from '@ringana/feature-service';
import { IFooterData } from '@/common/interfaces/footer.interface';
import config from '../../../config';
import FooterDesktop from './subcomponent/FooterDesktop.vue';
import FooterMobile from './subcomponent/FooterMobile.vue';
import CookieHelper from '../../helpers/CookieHelper';

export default Vue.extend({
  name: `Footer`,
  components: {
    FooterDesktop,
    FooterMobile,
  },
  data(): IFooterData {
    return {
      mobileView: true,
      newServiceTimesActive: false,
    };
  },
  created(): void {
    window.addEventListener(`resize`, this.reportWindowSize);
  },
  async mounted(): Promise<void> {
    this.newServiceTimesActive = await FeatureService.isActiveFeature(`WEB-3686`, CookieHelper.getAuthToken() || ``);
    this.reportWindowSize();
  },
  methods: {
    reportWindowSize(): void {
      this.mobileView = window.innerWidth < config.breakpoints.smallDesktop;
    },
  },
});
